module.exports = __webpack_public_path__ + "img/crowdpotato-thumbnail.7a279dd5.png";